"use client";
import React, { JSX, useCallback, useState } from "react";

const TextButton = ({
  text,
  style,
  onClick,
  isDisabled,
  Icon,
}: {
  text: string;
  style?: string;
  onClick?: () => Promise<void> | void;
  isDisabled?: boolean;
  Icon?: () => JSX.Element;
}) => {
  const [isBusy, setIsBusy] = useState(false);
  const onClickHandler = useCallback(async () => {
    if (!isDisabled && !isBusy) {
      setIsBusy(true);
      try {
        await onClick?.();
      } catch (error) {
        setIsBusy(false);
      }
      setIsBusy(false);
    }
  }, [isDisabled, onClick, isBusy]);

  return (
    <button
      className={`hover:underline ${style} ${isDisabled || isBusy ? "text-disabled" : "text-link"}`}
      onClick={onClickHandler}
      disabled={isDisabled || isBusy}
    >
      <div className="flex items-center gap-2">
        {Icon && <Icon />}
        <p>{text}</p>
      </div>
    </button>
  );
};

export default TextButton;
